// eslint-disable-next-line @typescript-eslint/no-implied-eval, no-new-func
export default (calculation: string) => Function(`"use strict"; return ${calculation}`)();
